import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 3a21 21 0 0 1 0 18","key":"svg-0"}],["path",{"d":"M19 3a21 21 0 0 0 0 18","key":"svg-1"}],["path",{"d":"M5 12l14 0","key":"svg-2"}]]

/**
 * IconZodiacPisces
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItem9kaWFjLXBpc2NlcyIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNSAzYTIxIDIxIDAgMCAxIDAgMTgiIC8+CiAgPHBhdGggZD0iTTE5IDNhMjEgMjEgMCAwIDAgMCAxOCIgLz4KICA8cGF0aCBkPSJNNSAxMmwxNCAwIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/zodiac-pisces
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconZodiacPisces = createReactComponent('outline', 'zodiac-pisces', 'ZodiacPisces', __iconNode);

export default IconZodiacPisces;